/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef } from 'react';

import { useCreditTrack } from '../../../../hooks/useCreditTrack';

import { MMcardProps } from './index';

export const useMMCard = ({ offer, user, position }: MMcardProps) => {
  // TODO: HANDLE FAVORITE

  const { productViewedEvent } = useCreditTrack();
  const cardRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      async (entries, observer) => {
        if (entries[0].isIntersecting) {
          productViewedEvent({
            offer,
            index: position,
            location: 'mm-v2',
            document: user?.cpf,
          });
          observer.unobserve(entries[0].target);
        }
      },
      {
        threshold: 0.5,
      }
    );

    if (cardRef.current) observer.observe(cardRef.current);
    return () => {
      if (cardRef.current) observer.unobserve(cardRef.current);
    };
  }, [cardRef]);

  return { cardRef };
};
